import React, { Component } from "react";
import { Menu, Segment, Sidebar,Message,Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import axios from "axios";

import Methodology from '../assets/Methodology.png'
// Child Components 
import TreeNode from "./TreeNodeV3";
import MapView from "./MapViewV3";
// Util Components
import colors from "../../colors";


// OnLoad Modal Page 
import AboutModal from "../../GeoportalModal";
import pagecontent from "../Helpers/FloodContent";
import menus from "../Helpers/menus";
import file_ext from "../Helpers/file-heads";
import domain from "../../domain";

import CheckBox from "./CheckBox";

import { FadeLoader } from "react-spinners";
/* Draggable Component */
import { Rnd } from "react-rnd";
/* Chart Component */
import GradientChart from "./GradientChart";
import MultiAxisChart from "./MultiAxisChart";
import MultiAxisChartHydrograph from "./MultiAxisChartHydrograph";

//import reservoirchart from "./reservoirchart";

import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { indexOf, sortBy } from "lodash";
import { DateRange } from "@material-ui/icons";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);
// Global functions 
function capitalize(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

function change_date(d) {
  var today = new Date(d);
  var dd = today.getDate();

  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "-" + mm + "-" + yyyy;
  return today;
}
var moment = require("moment");
var authType = "Basic";
var username = "NhpAdmin";
var password = "nhp@1234";
var basicAuth = authType + btoa(username + ":" + password);
axios.defaults.headers.common["Authorization"] = basicAuth;
/**
 * This class defines state variables of TreeNode & MapView Components
 * @MapContainer
 * 
 */
class MapContainer extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      //width: 800,
     // height: 450,
     width: Math.min(800, window.innerWidth * 0.9), // Adjust width for small screens
     height:Math.min(450, window.innerheight * 0.9),
      //x: 350,
      x: 0 ,//(window.innerWidth - 270 - 800) / 2,
      y:0 ,///window.innerHeight - 460,
      modal: true,
      stations: null,
      stations_tp:null,
      reservoirs:null,
      reservoirs_tp:null,
      catchment_tp:null,
      dates_avail:null,
      catchment:null,
      filename:null,

      //dates_avail:null,
      //volume_array:[],
      //y: window.innerHeight - 460,
      latestsimulations_names: null,
      simulationselected: '#',
      datesselected:'#',
      clickcount: 0,
      technicalnoteenable: false,
      disclaimerenable: false,
      baselayers: false,
      selectedMenu: null,
      time_rainfall:null,
      legendVisible: false,
      basinselection: false,
      subabsindata: null,
      loadingtab: false,
      curr_date: null,
      station: null,
      optionselected:"Inflow",

      //dates_avails:null,
      shown: false,
      month: null,
      modalpopup: false,
      villageaffected: false,
      villages_affected_data: null,
      basins: "",
      wms_url: `${domain.Geoserver}/nhp_flood/wms`,
      legend_array_overlay: {},
      inundationmapstatus: false,
      //activeIndex: 0,
      baselayerselected: "Basins",
      pointInfo: null,
      legend: null,
      selectedLayer: {},
      catchmentfilename:"#",
      visible: true,
      in_boundary: null,
      date: "",
      layerExist: true,
      wms_url_default: `${domain.Geoserver}/nhp_flood/wms`,
      latlng: { lat: null, lng: null },
      visibleGraphPanel: false,
      availableDates: [],
      selectedNodeStaus: {},
      slideTracker: -1,
      chartData: null,
      onClickDetails: {},
      stateInfo: null,
      dateEnabled: false,
      sliderEnabled: false,
      activeIndex: 0,
      zoom_reset: 0,
      forecast: false,
      information: null,
      forecast_date_gd:null,
      forecast_date_tp:null,

      himalayan_boundary: null,
      loading: false,
      missingDates: null,
      visibleDivPanel: false,
      village_legend: null,
      basinoverlays: [
        { id: 1, value: "Basin", isChecked: true },
        { id: 2, value: "Subbasin", isChecked: false },
        { id: 3, value: "River", isChecked: false },
        { id: 4, value: "HO", isChecked: false },
        { id: 5, value: "Reservoir", isChecked:true},
        // { id: 5, value: "Village", isChecked: false, disabled: true }
      ],
      basinselected: "Godavari", // <== Here, the values of selected options
      defaultsubbasin: false,
      subbasin: null,
      dsubbasin: null,
      graphdata: null,
      basin: null,
      subbasinstate: null,
      stats: null,
      forecastdate: null,
      inflow_title:null,
      volume_title:null,
      water_title:null,
      basininfo: null,
      indundation_map_boundary: null,
      charttitle: null,

      station_boundary: null,
      chartloading: true,
      HOchartData: null,
      yannotation: null,
      xannotation: null,
      categories: null,
      categories_hd:null,
      values: null,
      station_height: null,
      stationselected: "#",
      stationpoints_gd: null,
      reservoirsselected: "#",
      reservoirsselected_tp:'#',
      stationselected_tp: "#",
      datesselected:'#',
      catchmentselected:'#',
      stationpoints_tp: null,
      tabs: menus.mapSideBar,
      catchmentregion:null,
      catchmentcode:null,
    };
   
  }

  /*  tab Update Method & Click Method   */
  handleTabClick = (id) => {
    this.setSimulationChange('#')
    //this.setCatchmentChange('#')
    this.setSixHourSimulationChange("#")
    this.setState({
      tabs: this.updateTabs(id),
      visibleGraphPanel: false,
      series: null,
      series_hd:null,
      stationselected: '#',
      reservoirsselected:'#',
      stationselected_tp: '#',
      reservoirsselected_tp:'#',
      catchmentselected:'#',
      datesselected:'#',
      dates_avail:this.props.dates_avail,
    });

  };

  getCatchmentRegion=(date,time)=>{
    
      let region=this.state.catchmentregion
      let code=this.state.catchmentcode
      //console.log(region,code,"region,code",this.catchmentregion,this.props.catchmentregion,this.state.catchmentregion,this.state.catchmentcode)
    

    axios
    .get(`${domain.DBServer}/fetch-gd-stations-indundation-filename/${region}/${code}/${date}/${time}`)
    .then((result) => {
      if (result) { 
        this.setState({
          filename: result.data
    });
    if(this.state.filename)
    {
      let filename1;
      filename1=this.state.filename[0].filename.split(".")
      filename1=filename1[0]
      this.setState({
        catchmentfilename:filename1
      })
    //console.log("catch",this.state.catchmentfilename)
    }


  }
});
  }


  getAvailableDates=(region,code)=>{
    
    axios
      .get(`${domain.DBServer}/fetch-gd-stations-indundation-dates/${region}/${code}`)
      .then((result) => {
        if (result) {
          this.setState({
            dates_avail: result.data,
            catchmentregion:region,
            catchmentcode:code,
      });

    }
  });
  }

  updateTabs = (id) => {
    //console.log(id);
    let tabs = this.state.tabs;
    let newtabs = tabs.map((tab, index) => {
      if (tab.id === id) {
        if (tab.active === true) {
          tab.active = false;
        } else {
          tab.active = true;
        }
      } else {
        tab.active = false;
      }
      return tab;
    });
    //console.log(newtabs);
    return newtabs;
  }


  /** Enable/Disable Graph Panel */
  toggleVisibleGraphPanel = () => {
    if (this.state.series !== null) {
      this.setState({
        visibleGraphPanel: !this.state.visibleGraphPanel,
      });
    }
  }
  handleOptionChange= (value) => {
    
    let selectedoption = value;
    //console.log("selectedoption",selectedoption)
    this.setState((prevState) => ({
      optionselected: selectedoption,
     // x: prevState.x,
      //y: prevState.y,
      //width: prevState.width,
      //height: prevState.height,
    }));
  }
  toggleVisibleGraphPanel_hd= () => {
    if (this.state.series_hd !== null) {
      this.setState({
        visibleGraphPanel: !this.state.visibleGraphPanel,
      });
    }
  }

  toggleDivPanel = () => {
    this.setState({
      visibleDivPanel: !this.state.visibleDivPanel,
    });
  }
  /**  */
  handleVisibleGraphPanelOnMapClick = () => {
    this.setState({
      visibleGraphPanel: true,
    });
  }




  setDate = (date) => {
    this.setState({
      activeDate: date,
    });
  }

  handleStationChange_map = (value) => {
    //console.log(value);
    this.setState({
      station_boundary: value,
    });
  }


 


  onDragStop = (e, d) => {
    const newX = Math.max(0, d.x);
    const newY = Math.max(0, d.y);
    //console.log("Dragging to:", newX, newY);
    this.setState((prevState) => ({
      ...prevState,
      x: newX,
      y: newY,
    }));
  };

  onResizeStop = (e, direction, ref, delta, position) => {
    const newWidth = Math.max(0, ref.offsetWidth);
    const newHeight = Math.max(0, ref.offsetHeight);
    //console.log("Resizing to:", newWidth, newHeight);
    this.setState((prevState) => ({
      ...prevState,
      width: newWidth,
      height: newHeight,
      // Keep position unchanged on resize
    }));
  };







  /** Chartdata generation method  */
//   handleStationChartNew = (value,volume_data,max_forecast,region) => {
//     //console.log("max_forecast",max_forecast);
//     let availableDatesStr = [];
//     this.setState({ chartloading: true });
//     let station=region
//     let height;
//     let chartData = [];
//     let chartDates = [];
//     let date=[];
//     let dateTime=[];
//     let discharge=[];
  
//     let volume_values=[];
//     let volume_dates=[];
//     let vol_date=[];
//     let waterlevel=[];
//     let forecastdate;
//     //forecastdate=max_forecast
//     forecastdate=max_forecast



//     //console.log("funnnnn",value,volume_data,max_forecast)
//     for (const info of value ) {
//       //console.log("time",info.time)
//       var momentObj = moment(info.date, 'YYYY-MM-DDTHH:mm:ss');

//       // conversion
//        date = momentObj.format('YYYY-MM-DD HH:mm');
//       dateTime.push(date);
//       discharge.push(info.discharge);
//       //volume.push(info.volume).toFixed(2);
//       waterlevel.push(info.waterlevel);
//     }
    
//     for (const info_v of volume_data ) {

//      var momentObj = moment(info_v.date, 'YYYY-MM-DDTHH:mm:ss');

//      // conversion
//       vol_date = momentObj.format('YYYY-MM-DD HH:mm');
//      volume_dates.push(vol_date);
//      volume_values.push(info_v.volume);
//      //volume.push(info.volume).toFixed(2);
    
//    }

//    for (let i = 0; i < dateTime.length; i++) {
//     if( volume_dates.includes(dateTime[i])===true){
//     }
//     else{
//       volume_values.splice(i,0,null)
//     }
//   }

 
//   /*
//     value.map((r) => {
//       availableDatesStr.push(moment(r.date).format("YYYYMMDD"));
//       return true;
//     });
//     value.map((r) => {
//       chartData.push([
//         moment(r.date).format("D MMM YYYY HH:00:00"),
//         Number(r.time).toFixed(0),
//       ]);
//       return true;
//     });
//     height = value.map((r) => {
//       return Number(r.hfd);
//     });

//     availableDatesStr.forEach((date_i) => {
//       //console.log(date_i);
//       chartDates.push(
//         moment(date_i, "YYYYMMDDHHMMSS").format("D MMM YYYY HH:00:00")
//       );
//       return true;
//     });
//     // //console.log(availableDatesStr.length)
//     // //console.log(chartDates.sort());

//     let data2 = [];
//     for (let i = 0; i < chartDates.length; i++) {
//       let dd = new Date(chartDates[i]);
//       //console.log("dd",dd);
//       let y = dd.getFullYear();
//       let m = dd.getMonth();
//       let d = dd.getDate();
//       let h = dd.getHours();
//       data2.push([Date.UTC(y, m, d, h), chartData[i]]);
//     }
//     // data2.sort();
//     // chartData.sort();
//     //console.log(chartData);
//     */

//     this.setState({
//       series: [discharge, waterlevel,volume_values],


//       // charttitle:
//       //   "Reservoirs Forecast at " +
//       //   station + 
//       //   " on " +
//       //   moment("2023-10-03", "YYYY-MM-DD").format("DD-MMMM-YYYY") + "  14:00:00",
//       // curr_date: "2023-10-03",

//       charttitle:
//       "Reservoirs Forecast at " +
//       station + 
//       " on " +
//       moment(forecastdate, "YYYY-MM-DD").format("DD-MMMM-YYYY") +"  14:00:00",
//     curr_date: forecastdate,

//      // station_height: height[0],
//       // yannotation:10000,
//       // xannotation:curr_date,
//       visibleGraphPanel: true,
//       technicalnoteenable: false,
//       disclaimerenable: false,
//       chartloading: false,
//       categories: [dateTime,volume_dates],
//       inflow_title:"Discharge (m^3 / s)",
//       volume_title:"Volume (m^3)",
//       water_title:"Water Level (m)",

//       visible: window.innerWidth > 1000 ? true : false,
//     });
//   };

handleStationChartNew = (value, volume_data, max_forecast, region) => {
    //console.log("max_forecast", max_forecast);
    this.setState({ chartloading: true });
    
    let station = region;
    let discharge = [];
    let waterlevel = [];
    let volume_values = [];
    let dateTime = [];
    let volume_dates = [];
    let forecastdate = max_forecast;

    //console.log("Input values:", value, volume_data, max_forecast);

    // Process value data
    for (const info of value) {
        //console.log("Processing time:", info.time);
        let momentObj = moment(info.date, 'YYYY-MM-DDTHH:mm:ss');
        dateTime.push(momentObj.format('YYYY-MM-DD HH:mm'));
        discharge.push(info.discharge);
        waterlevel.push(info.waterlevel);
    }

    // Process volume data
    for (const info_v of volume_data) {
        let momentObj = moment(info_v.date, 'YYYY-MM-DDTHH:mm:ss');
        volume_dates.push(momentObj.format('YYYY-MM-DD HH:mm'));
        volume_values.push(info_v.volume);
    }

    // Ensure volume_values align with dateTime
    for (let i = 0; i < dateTime.length; i++) {
        if (!volume_dates.includes(dateTime[i])) {
            volume_values.splice(i, 0, null);
        }
    }

    // Handle case where value is empty
    if (value.length === 0) {
        discharge = new Array(volume_dates.length).fill(null);
        waterlevel = new Array(volume_dates.length).fill(null);
    }

    //console.log('DateTime:', dateTime);
    //console.log('Volume Dates:', volume_dates);
    //console.log('Discharge:', discharge);
    //console.log('Water Level:', waterlevel);
    //console.log('Volume Values:', volume_values);

    this.setState({
        series: [discharge, waterlevel, volume_values],
        charttitle: `Reservoirs Forecast at ${station} on ${moment(forecastdate, "YYYY-MM-DD").format("DD-MMMM-YYYY")} 14:00:00`,
        curr_date: forecastdate,
        visibleGraphPanel: true,
        technicalnoteenable: false,
        disclaimerenable: false,
        chartloading: false,
        categories: [dateTime.length > 0 ? dateTime : volume_dates, volume_dates],
        inflow_title: "Discharge (m^3 / s)",
        volume_title: "Volume (m^3)",
        water_title: "Water Level (m)",
        visible: window.innerWidth > 1000,
    });
};



  handleStationChange_map = (value) => {
    //console.log(value);
    this.setState({
      station_boundary: value,
    });
  }
  /** Chartdata generation method  */
  handleStationChart = (value,forecast_data,max_forecast,region) => {

    //console.log("rainfall,forecast",value,forecast_data,max_forecast)
    let availableDatesStr = [];
    let station=region
    this.setState({ chartloading: true });
    let height;
    let chartData = [];
    let chartDates = [];

    let date_hd=[];
    let dateTime_hd=[];
    let rainfall=[];
    let forecast_values=[];
    let forecast_dates=[];
    let forecast_date=[];
    let forecastdate=max_forecast;

    for (const info of value ) {

      var momentObj = moment(info.date, 'YYYY-MM-DDTHH:mm:ss');

      // conversion
       date_hd = momentObj.format('YYYY-MM-DD HH:mm');
      dateTime_hd.push(date_hd);
      rainfall.push(info.rainfall);
      //volume.push(info.volume).toFixed(2);
    }

    //console.log("rainvalues and corresponding dates",dateTime_hd,rainfall)

   
    for (const info_v of forecast_data ) {

     var momentObj = moment(info_v.date, 'YYYY-MM-DDTHH:mm:ss');

     // conversion
      forecast_date = momentObj.format('YYYY-MM-DD HH:mm');
     forecast_dates.push(forecast_date);
     forecast_values.push(info_v.forecast);

   }
   
//console.log("rainfall values and forecast_values", dateTime_hd,forecast_dates,rainfall,forecast_values,rainfall.length,forecast_values.length)
let rain_new=[]; 
let dates_new=[];
let forecast_new=[];
for (let i =0; i<dateTime_hd.length;i++)
{
  dates_new.push(dateTime_hd[i])
}
  for (let j=0;j<forecast_dates.length;j++)
  {
    dates_new.push(forecast_dates[j])
}
//console.log(dates_new.length)
dates_new=new Set(dates_new)
//console.log(dates_new,rain_new.length,forecast_new.length,dates_new.length)
//console.log("type",dates_new[1],typeof(dates_new[1]))
//dates_new.sort(function(a, b){return a - b})
//dates_new.sort(function(a,b){return a.getTime() - b.getTime()});

let date_new=[...dates_new].sort()
let count=0
//console.log("HHHHHHHHH",date_new)
let dates_chart=[]
for (let k=0; k<date_new.length; k++)
{
  //console.log("out",date_new[k],k)

  if(dateTime_hd.includes(date_new[k])===true)
  
  {
    //console.log("in",date_new[k])

   
    rain_new.push(rainfall[count])
    count=count+1

  }
  else {

    rain_new.push(rainfall[count])

}

  

}
//console.log("newrain",rain_new)

let cnt=0
for (let l=0; l<date_new.length; l++)
{
  //console.log("out",date_new[l],l)

  if(forecast_dates.includes(date_new[l])===true)
  
  {
    //console.log("in",date_new[l])
   
    forecast_new.push(forecast_values[cnt])
    cnt=cnt+1
  }
  else
  forecast_new.push(forecast_values[cnt])
}
//console.log("forecast rain dates",forecast_new,rain_new,date_new)


/*
  for (let i = 0; i < forecast_dates.length; i++) {

    if( dateTime_hd.includes(forecast_dates[i])===true){
      //console.log("forecast_dates[i]",forecast_dates[i])

    }
    else{
      
      rainfall.splice(i,0,null)
    }
  }



   //from here need to be change
   for (let i = 0; i < forecast_dates.length; i++) {
    ////console.log(":::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::",i)
    if( volume_dates.includes(dateTime[i])===true){
}
    else{
      volume_values.splice(i,0,null)
    }
}
*/
   /* value.map((r) => {
      availableDatesStr.push(moment(r.date).format("YYYYMMDD"));
      //console.log(availableDatesStr)
      return true;
    });
    value.map((r) => {
      chartData.push([
        moment(r.date).format("D MMM YYYY HH:00:00"),
        Number(r.rainfall),
      ]);
      return true;
    });
    height = value.map((r) => {
      return Number(r.hfd);
    });

    availableDatesStr.forEach((date_i) => {
      //console.log(date_i);
      chartDates.push(
        moment(date_i, "YYYYMMDDHHMMSS").format("D MMM YYYY HH:00:00")
      );
      return true;
    });
    // //console.log(availableDatesStr.length)
    // //console.log(chartDates.sort());

    let data2 = [];
    for (let i = 0; i < chartDates.length; i++) {
      let dd = new Date(chartDates[i]);
      //console.log(dd,"DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD");
      let y = dd.getFullYear();
      let m = dd.getMonth();
      let d = dd.getDate();
      let h = dd.getHours();
      data2.push([Date.UTC(y, m, d, h), chartData[i]]);
    }
    // data2.sort();
    // chartData.sort();
    //console.log(chartData);

    */
    if (forecast_data.length!==0){
    this.setState({
      series_hd: [rain_new,forecast_new],

      // charttitle_hd:
      //   "Hydrograph at " +
      //   station +
      //   " on " +
      //   moment("2023-10-03",  "YYYY-MM-DD").format("DD-MMMM-YYYY") +"  14:00:00",
      // curr_date: "2023-10-03",

      charttitle_hd:
        "Hydrograph Forecast at " +
        station + 
        " on " +
        moment(forecastdate,  "YYYY-MM-DD").format("DD-MMMM-YYYY") +"  14:00:00" ,
      curr_date: forecastdate,

     
      //station_height: height[0],
      // yannotation:10000,
      // xannotation:curr_date,
      visibleGraphPanel: true,
      technicalnoteenable: false,
      disclaimerenable: false,
      chartloading: false,
      categories_hd: date_new,
     // time_rainfall:"14:00",
      visible: window.innerWidth > 1000 ? true : false,
    });
  }
  else{
    this.setState({
      series_hd: [rainfall,[]],
      // charttitle_hd:
      //   "Hydrograph at " +
      //   station +
      //   " on " +
      //   moment("2023-10-03",  "YYYY-MM-DD").format("DD-MMMM-YYYY") +"  14:30:00",
      // curr_date: "2023-10-03",
      charttitle_hd:
      "Hydrograph Forecast at " +
      station + 
      " on " +
      moment(forecastdate,  "YYYY-MM-DD").format("DD-MMMM-YYYY"),
    curr_date: forecastdate,


      //station_height: height[0],
      // yannotation:10000,
      // xannotation:curr_date,
      visibleGraphPanel: true,
      technicalnoteenable: false,
      disclaimerenable: false,
      chartloading: false,
      categories_hd: date_new,
     // time_rainfall:"14:30",

      visible: window.innerWidth > 1000 ? true : false,
    });
  }
  };





  setBasinSelected = (basin) => {
    this.setState({
      basinselected: basin,
    });
  }

  onUpdateBasin = (result) => {
    //console.log(result);
    this.setState({
      basininfo: result,
    });
  }

  toggleSelectedNodeStatus = (menu) => {
    //console.log(menu);
    let selectedNodeStaus = { ...this.state.selectedNodeStatus };

    selectedNodeStaus[menu] = !selectedNodeStaus[menu];

    this.setState({
      selectedNodeStaus: selectedNodeStaus,

    });

  }

  enableDatePicker = (status) => {
    this.setState({
      dateEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  }
  enableForecast = (status) => {
    this.setState({
      forecast: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  enableSlider = (status) => {
    this.setState({
      sliderEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  handleAnimationChange = () => {
    this.setState({
      visible: !this.state.visible,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  setSelectedMenu = (menu, basin) => {
    //console.log("menu,basin",menu, basin);

    let string = menu.toLowerCase().split(" ");
    //console.log("menu",menu);

    if (string[0] === "#") this.getAvailableDates_url("Hydrograph", basin);
    else if (string[0] === "latest")
      this.getAvailableDates_url_in("latest_indun", basin, this.state.date);
    else if (string[0] === "historical")
      this.getAvailableDates_url_in("historical_indun", basin, this.state.date);
    this.setState({
      selectedMenu: menu,
      visibleGraphPanel: false,
      station_boundary: null,
      stationselected: null,
      reservoirsselected: null,
      stationselected_tp: null,
      reservoirsselected_tp: null,
      catchmentselected:null,
      datesselected:null,
      series_hd:null,
      series: null,
      // lastSelected: menu
    });
  };
  setSimulationChange = (selected) => {
    let selectedLayer = { ...this.state.selectedLayer };
    //    //console.log(main,basin,selected)
    if (selected !== "#") {
      if (selected.split("_")[0] === "fim") {
        selectedLayer[this.state.selectedMenu] = selected.split(".")[0];
        if (this.state.basinselected === "Godavari") {
          axios
            .get(`${domain.DBServer}/fetch-IN-Boundary-GD/${selected}`)
            .then((result) => {
              if (result) {
                //console.log(result);
                this.setState({
                  in_boundary: result.data[0].boundary,
                  selectedLayer: selectedLayer,
                  simulationselected: selected,
                  zoom_reset: 0,
                });
              }
            });
        } else if (this.state.basinselected === "Tapi") {
          axios
            .get(`${domain.DBServer}/fetch-IN-Boundary-TP/${selected}`)
            .then((result) => {
              if (result) {
                this.setState({
                  in_boundary: result.data[0].boundary,
                  selectedLayer: selectedLayer,
                  simulationselected: selected,
                  zoom_reset: 0,
                });
              }
            });
        }

        // this.setState({

        //   // selectedMaps:selectedMaps
        // });
      }
    } else if (selected === "#") {
      if (this.state.basinselected === "Godavari") {
        //  this.getBaseLayer_in(this.state.basinselected)
        this.setState({
          // selectedLayer:null,
          in_boundary: null,
          legend: null,
          zoom_reset: 5,
          selectedLayer: "basin",
          simulationselected: selected,
        });
      } else if (this.state.basinselected === "Tapi") {
        // this.getBaseLayer_in(this.state.basinselected)
        this.setState({
          // selectedLayer:null,
          in_boundary: null,
          legend: null,
          zoom_reset: 5,
          selectedLayer: "basin",
          simulationselected: selected,
        });
      }
    }
  };

  setSixHourSimulationChange = (selected) => {
    let selectedLayer = { ...this.state.selectedLayer };
     //console.log("selected",selected)
    if (selected !== "#") {
      
        if (this.state.basinselected === "Godavari") {
          axios
            .get(`${domain.DBServer}/fetch-inundation-godavari-boundaries/${selected}`)
            .then((result) => {
              if (result) {
                //console.log(result);
                this.setState({
                  in_boundary: result.data[0].boundary,
                  selectedLayer: selectedLayer,
                  simulationselected: selected,
                  zoom_reset: 0,
                });
              }
            });
        } else if (this.state.basinselected === "Tapi") {
          axios
            .get(`${domain.DBServer}/fetch-IN-Boundary-TP/${selected}`)
            .then((result) => {
              if (result) {
                this.setState({
                  in_boundary: result.data[0].boundary,
                  selectedLayer: selectedLayer,
                  simulationselected: selected,
                  zoom_reset: 0,
                });
              }
            });
        }
      
    } else if (selected === "#") {
      if (this.state.basinselected === "Godavari") {
        //  this.getBaseLayer_in(this.state.basinselected)
        this.setState({
          // selectedLayer:null,
          in_boundary: null,
          legend: null,
          zoom_reset: 5,
          selectedLayer: "basin",
          simulationselected: selected,
        });
      } else if (this.state.basinselected === "Tapi") {
        // this.getBaseLayer_in(this.state.basinselected)
        this.setState({
          // selectedLayer:null,
          in_boundary: null,
          legend: null,
          zoom_reset: 5,
          selectedLayer: "basin",
          simulationselected: selected,
        });
      }
    }
  };

  getAvailableDates_url_in = (value, basin, date) => {
    //console.log(value);
    let stringdate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    let availablenames = [];

    axios
      .get(`${domain.DBServer}/fetch-${value}-${basin}/${stringdate}`)
      .then((result) => {
        if (result) {
          //console.log(result);
          if (result.data) {
            result.data.map((r) => {
              availablenames.push(r.filename);
              return true;
            });
          }
          availablenames.sort();
          this.setState({
            latestsimulations_names: availablenames,
          });
        }
      });
  };
  setBoundary = (value) => {
    let mod = value + ".tif";
    axios
      .get(`${domain.DBServer}/fetch-IN-Boundary-GD/${mod}`)
      .then((result) => {
        if (result) {
          this.setState({
            indundation_map_boundary: result.data[0],
          });
        }
      });
  };
  setBoundary_t = (value) => {
    let mod = value + ".tif";
    axios
      .get(`${domain.DBServer}/fetch-IN-Boundary-TP/${mod}`)
      .then((result) => {
        if (result) {
          this.setState({
            indundation_map_boundary: result.data[0],
          });
        }
      });
  };
  setSelectedLayer = (main, basin, selected) => {
    let selectedLayer = { ...this.state.selectedLayer };
    //console.log(main, basin, selected);
    if (selected) {
      if (selected.split("_")[0] === "fim") {
        selectedLayer[main] = selected.split(".")[0];

        this.setState({
          selectedLayer: selectedLayer,

          // selectedMaps:selectedMaps
        });
      }
    }
  };
  displayLegend = () => {
    this.setState({ legendVisible: !this.state.legendVisible });
  };
  enableVisibleGraphPanel = (status) => {
    this.setState({
      visibleGraphPanel: status,
    });
  };
  setStateInfo = (info) => {
    this.setState({
      stateInfo: info,
    });
  };

  setLegend = (src) => {
    this.setState({
      legend: src,
    });
  };

  setLatLng = (latlng) => {
    this.setState({
      latlng: latlng,
    });
  };

  setOnClickDetails = (data) => {
    this.setState({
      onClickDetails: data,
    });
  };

  makeChartDataAvailableDaysWithDateCats = (
    active_layer,
    wms_url,
    lat,
    longitude,
    height,
    width,
    bbox
  ) => {
    let availableDatesStr = [],
      chartData = [];
    let chartDates = [];

    let url = this.state.selectedMenu.toLowerCase().split(" ").join("-");
    axios
      .get(`${domain.DBServer}/fetch-${url}/${longitude}/${lat}`)
      .then((result) => {
        //console.log(result.data);
        result.data.map((r) => {
          availableDatesStr.push(moment(r.date).format("YYYYMMDD"));
          return true;
        });
        result.data.map((r) => {
          chartData.push(Number(r.st_value).toFixed());
          return true;
        });
        //console.log(chartData.length);
        // availableDatesStr.reverse()
        // //console.log(availableDatesStr)
        availableDatesStr.forEach((date_i) => {
          chartDates.push(moment(date_i, "YYYYMMDD").format("D MMM YYYY"));
          return true;
        });
        // //console.log(availableDatesStr.length)
        //console.log(chartDates);

        let data2 = [];
        for (let i = 0; i < chartDates.length; i++) {
          let dd = new Date(chartDates[i]);
          //console.log(dd);
          let y = dd.getFullYear();
          let m = dd.getMonth();
          let d = dd.getDate();
          data2.push([Date.UTC(y, m, d), chartData[i]]);
        }
        data2.sort();
        //console.log(data2);

        this.setState({
          pointInfo: chartData[0],

          chartData: {
            seriesData: data2,
            categories: chartDates,
            title: `${this.state.selectedMenu}`,

            yAxisTitle: `value`,
            xAxisTitle: "Days",
            name: this.state.selectedMenu,
            type: "bar",
          },
        });
      });
  };

  async doesLayerExist(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",

        // propertyNames:property
      },
      // headers: {"Access-Control-Allow-Origin": "*"},
      withCredentials: true,
    });
    // //console.log(result.data.layerDescriptions)

    if (result.data.layerDescriptions !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  async describeLayer(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",
        // propertyNames:property
      },
      // headers: {"Access-Control-Allow-Origin": "*"},
      withCredentials: true,
    });
    // //console.log(result.data.layerDescriptions)

    return result.data;
  }

  async getFeatureInfo(wms_url) {
    let result = await axios.get(wms_url);

    return new Promise((resolve) => {
      resolve(result);
    });
    // return result
  }

  getAvailableDates_url = (wms_url, value) => {
    let availableDates = [];

    let basin = value === "Godavari" ? "gd" : "tp";
    //console.log(basin);
    axios.get(`${domain.DBServer}/fetch-${wms_url}/${basin}`).then((result) => {
      if (result) {
        //console.log(result);
        if (result.data) {
          result.data.map((r) => {
            availableDates.push(moment(r.actual_date));
            return true;
          });
          let status = result.data.map((r) => {
            return r.map_a;
            //  return true
          });
          //  //console.log(status[0])
          let maxdate = moment.max(availableDates).format("DD-MM-YYYY");
          //console.log(maxdate);
          //  let maxdate_2=moment("18-08-2020").format("DD-MM-YYYY")
          //  //console.log(maxdate_2)

          let maxdate_1 = moment.max(availableDates).format("YYYY-MM-DD");
          let sortedDates = availableDates.sort(
            (a, b) => a.valueOf() - b.valueOf()
          );
          //console.log(maxdate_1, basin, status);
          this.setState({
            availableDates: sortedDates,
            date: maxdate,
            slideTracker: sortedDates.length - 1,
            loading: true,
            inundationmapstatus: status[0],
          });
        }
      }
    });
  };

  handleDateChange = (event, { name, value }) => {
    let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let availableDates = [...this.state.availableDates];
    let availableDatesStr = availableDates.map((date) => {
      return moment(date, "DD-MM-YYYY").format("YYYYMMDD");
    });
    axios
      .get(`${domain.DBServer}/fetch-in-status/${selected_date}`)
      .then((result) => {
        if (result) {
          if (this.state.hasOwnProperty(name)) {
            this.setState({
              [name]: value,
              selectedLayer: selectedLayer,
              slideTracker: availableDatesStr.indexOf(selected_date),
              layerExist: true,
              loading: false,
              inundationmapstatus: result.data[0].map_a,
              visibleGraphPanel: false,
              basinselected: "Godavari",
              stationselected: "#",
              reservoirsselected:"#",
              stationselected_tp: "#",
              reservoirsselected_tp:"#",
              catchmentselected:'#',
              datesselected:'#',
            });
          }
        }
      });
    // //console.log(value)
    // selectedLayer[this.state.selectedMenu] = selected_date + file_ext[this.state.selectedMenu]
  };

  onSlide = (value) => {
    let selected_date = moment(
      this.state.availableDates[value],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };

    let menu = this.state.selectedMenu;

    selectedLayer[menu] = selected_date + file_ext[menu];

    axios
      .get(`${domain.DBServer}/fetch-in-status/${selected_date}`)
      .then((result) => {
        if (result) {
          this.setState({
            slideTracker: value,
            date: this.state.availableDates[value],
            selectedLayer: selectedLayer,
            inundationmapstatus: result.data[0].map_a,
            visibleGraphPanel: false,
            basinselected: "Godavari",
            stationselected: "#",
            datesselected:'#',
            reservoirsselected: "#",
            catchmentselected:'#',
            reservoirsselected_tp: "#",
            catchmentselected_tp:'#',
            
          });
        }
      });
  };

  onClickSlideLeft = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker > 0) {
      slideTracker = slideTracker - 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = selected_date + file_ext[menu];
    // })

    var d = new Date(
      moment(this.state.availableDates[slideTracker], "DD-MM-YYYY")
    );
    var str_date = change_date(d);
    //console.log(str_date);
    axios
      .get(`${domain.DBServer}/fetch-in-status/${selected_date}`)
      .then((result) => {
        if (result) {
          this.setState({
            slideTracker: slideTracker,
            date: str_date,
            selectedLayer: selectedLayer,
            inundationmapstatus: result.data[0].map_a,
            visibleGraphPanel: false,
            basinselected: "Godavari",
            stationselected: "#",
            reservoirsselected: "#",
            stationselected_tp: "#",
            reservoirsselected_tp: "#",
            catchmentselected:'#',
            datesselected:'#',

          });
        }
      });
    // this.setState({
    //     slideTracker:slideTracker,
    //     date:str_date,
    //     selectedLayer:selectedLayer,
    // })
  };

  onClickSlideRight = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker < this.state.availableDates.length - 1) {
      slideTracker = slideTracker + 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = selected_date + file_ext[menu];
    // })
    var d = new Date(
      moment(this.state.availableDates[slideTracker], "DD-MM-YYYY")
    );
    var str_date = change_date(d);
    //console.log(str_date);
    axios
      .get(`${domain.DBServer}/fetch-in-status/${selected_date}`)
      .then((result) => {
        if (result) {
          this.setState({
            slideTracker: slideTracker,
            date: str_date,
            selectedLayer: selectedLayer,
            inundationmapstatus: result.data[0].map_a,
            visibleGraphPanel: false,
            basinselected: "Godavari",
            stationselected: "#",
            reservoirsselected: "#",
            stationselected_tp: "#",
            reservoirsselected_tp: "#",
            catchmentselected:"#",
            datesselected:'#',

          });
        }
      });
    // this.setState({
    //     slideTracker:slideTracker,
    //     date:str_date,
    //     selectedLayer:selectedLayer,
    // })
  };
  getBaseLayer = (basin) => {
    axios.get(`${domain.DBServer}/get-indian-basin/${basin}`).then((result) => {
      if (result) {
        this.setState({
          basininfo: result.data[0].basin_boundary,
        });
        // count1=count1+1
      }
    });
  };
  getBaseLayer_in = (basin) => {
    axios.get(`${domain.DBServer}/get-indian-basin/${basin}`).then((result) => {
      if (result) {
        this.setState({
          basininfo: result.data[0].basin_boundary,
        });
        // count1=count1+1
      }
    });
  };
  setDefaultInfo = (text) => {
    this.setState({
      information: text,
    });
  };

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14`;

    return img_src;
  }

  getLegend = (overlay) => {
    let wms_url = this.state.wms_url;

    let legend_array_overlay = {};

    overlay.map((layer) => {
      if (layer.isChecked) {
        this.getLegendGraphic(
          wms_url,
          "nhp_flood:nhp_fews_" + this.state.basinselected + "_" + layer.value
        ).then((legend) => {
          //console.log(legend);
          legend_array_overlay[layer.value] = legend;
          this.setState({
            legend_array_overlay: legend_array_overlay,
            legendVisible: true,
          });
        });
      }
      return true;
    });
  };
  // getVillageAffected=()=>{
  //   axios.get(`${domain.DBServer}/get-villages-affected`).then((result) => {
  //     if (result) {
  //       this.setState({
  //         villageaffected: result.data[0].boundary,
  //       });
  //       // count1=count1+1
  //     }
  //   });
  // }
  async componentDidMount() {
    //  this.getAvailableDates()
    let result = await axios.get(`${domain.DBServer}/fetch-gd-stations-hydrograph`)
    //console.log(result,"componentdidmount")
    if (result) {
      this.setState({
        stations: result.data
      })
    }
    let result_tp = await axios.get(`${domain.DBServer}/fetch-tp-stations-hydrograph`)
    //console.log(result_tp)
    if (result_tp) {
      this.setState({
        stations_tp: result_tp.data
      })
    }

    let result_res = await axios.get(`${domain.DBServer}/fetch-gd-stations-reservoir`)
    //console.log(result_res)
    if (result_res) {
      this.setState({
        reservoirs: result_res.data
      
      })
      
    } 
    let result_date = await axios.get(`${domain.DBServer}/fetch-fews-update-date-godavari`)
    .then((result_date) => {
      if (result_date) {
        //console.log("update",result_date.data,result_date.data);
        this.setState({forecast_date_gd:result_date.data})
        //this.setState({forecast_date_gd:[{"max":"2023-12-07"}]})

        //console.log("forecast_date_gd",this.state.forecast_date_gd)
      }
    });
    let result_date_tp = await axios.get(`${domain.DBServer}/fetch-fews-update-date-tapi`)
    .then((result_date_tp) => {
      if (result_date_tp) {
        //console.log("update",result_date_tp.data);
        //this.setState({forecast_date_tp:[{"max":"2023-12-07"}]});
        this.setState({forecast_date_tp:result_date_tp.data});

        //console.log("forecast_date_tp",this.state.forecast_date_tp)
      }
    });  
    let result_res_tp = await axios.get(`${domain.DBServer}/fetch-tp-stations-reservoir`)
    //console.log(result_res_tp)
    if (result_res_tp) {
      this.setState({
        reservoirs_tp: result_res_tp.data
      
      })
      
    }

    let result_res1 = await axios.get(`${domain.DBServer}/fetch-gd-stations-indundation-regions`)
    //console.log(result_res1)
    if (result_res1) {
      this.setState({
      catchment: result_res1.data     
      })
    }
/*
    let result_res1_tp = await axios.get(`${domain.DBServer}/fetch-tp-stations-indundation-regions`)
    //console.log(result_res1_tp)
    if (result_res1_tp) {
      this.setState({
      catchment_tp: result_res1_tp.data     
      })
    }
    */
    this.getBaseLayer(this.state.basinselected);
    // this.getVillageAffected()
    this.getLegend(this.state.basinoverlays);
    if (window.innerWidth > 300 && window.innerWidth < 1000) {
      this.setState({
        visible: false,
        legendVisible: false,
        x: 0,
        y: 0,
        width: 300,
        height: 300

      })
    }
    else if (window.innerWidth >= 1000 && window.innerWidth < 1100) {
      this.setState({
        visible: false,
        legendVisible: false,
        x: 0,
        y: 0,
        width: 500,
        height: 300

      })
    }
    //    //console.log(this._menuBlock.offsetHeight)
    //    //console.log(this._menuBlock.clientHeight)

    //        this.setState({
    //            x:350,
    //            y:this._menuBlock.clientHeight-320
    //        });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.date !== prevState.date ||
      this.state.selectedMenu !== prevState.selectedMenu ||
      this.state.simulationselected !== prevState.simulationselected
    ) {
      //console.log(this.state.selectedMenu);
      this.setSelectedLayer(
        this.state.selectedMenu,
        this.state.basinselected,
        this.state.simulationselected
      );
    }
    if (this.state.selectedMenu !== prevState.selectedMenu) {
      //  this.makeChartDataAvailableDaysWithDateCats()
    }
    if (this.state.basinselected !== prevState.basinselected) {


    }
    if (this.state.inflow_waterlevel!==null){}
    
    

  }
  handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex });
  handleRowClick = (result) => {
    this.setState({
      activeIndex: 1,
      subabsindata: result,
    });
  };

  stationPoints = (value) => {
    //console.log(value);
    if (value === "Godavari") {
      axios.get(`${domain.DBServer}/fetch-GD-points`).then((result) => {
        if (result) {
          //console.log(result);
          this.setState({
            stationpoints_tp: null,

            stationpoints_gd: result.data[0].gd_stations,
          });
        }
      });
    } else if (value === "Tapi") {
      axios.get(`${domain.DBServer}/fetch-TP-points`).then((result) => {
        if (result) {
          this.setState({
            stationpoints_gd: null,
            stationpoints_tp: result.data[0].tp_stations,
          });
        }
      });
    }      
  };
  /* this is commented as it is not rendering
  getReservoir = async (basin) => {
    if (basin === 'Godavari') {
      //const controller = new AbortController();

      let result = await axios.get(`${domain.DBServer}/fetch-gd-stations-reservoir`)
      if (result) {

        //console.log("getstations",result)
        this.setState({
          reservoirs: result.data
        })
      }
    }
    else if (basin === 'Tapi') {
      let result = await axios.get(`${domain.DBServer}/fetch-tp-stations-reservoir`)
      if (result) {
        //console.log("get",result)
        this.setState({
          reservoirs: result.data
        })
      }
    }
  }
  */

  getStations = (basin) => {
    if (basin !== '#') {
      //console.log("basin",basin)
      this.setState({
        basinselected: basin})

  }
}
  handleBasinChange = (e) => {
    //console.log(e.target.value);

    this.getStations(e.target.value)

    this.setStationChange("#");

    this.setReservoirChange("#");
    //this.setStationChange_tp("#");

    //this.setReservoirChange_tp("#");

   // //console.log("this.state.selectedMenu",this.state.selectedMenu)

   // let string = this.state.selectedMenu.toLowerCase().split(" ");
    ////console.log(string[0]);
    //this.toggleSelectedNodeStatus("Hydrograph-#");
    //this.setSimulationChangeNew("#");

    // this.setSelectedMenu('#')

   // if (string[0] === "latest")
     // this.getAvailableDates_url_in(
       // "latest_indun",
        //e.target.value,
        //this.state.date
      //);
    //else if (string[0] === "historical")
     // this.getAvailableDates_url_in(
      //  "historical_indun",
        //e.target.value,
        //this.state.date
      //);

    this.getAvailableDates_url("Hydrograph", e.target.value);

    // (this.state.selectedMenu.s==='Histori')
    // this.getAvailableDates_url_in('')
    // this.setSelectedMenu('Hydrograph',e.target.value)
    // this.setSelectedLayer('Hydrograph',e.target.value)
    this.getBaseLayer(e.target.value);
    this.setState({
      basinselected: e.target.value,
      //selectedLayer:null
      visibleGraphPanel: false,
      station_boundary: null,
      legend: null,
      selectedMenu: "#",
      in_boundary: null,
      station_height: null,
      // legendVisible:false,
      //    stationselected:null,
      series: null,
      indundation_map_boundary: null,
    });
  };

  setStationChange = (station) => {
    if (station !== '#') {
      this.setState({
        stationselected: station,
        catchmentselected:'#',
        catchmentfilename:'#',
        datesselected:'#',
        reservoirsselected:'#',
        legend: null,
        //  legendVisible:false
      });
    }
    else {
      this.setState({
        visibleGraphPanel: false,
        series: null,
        stationselected: station
      })
    }
  };
  /*
  setStationChange_tp = (station_tp) => {
    if (station_tp !== '#') {
      this.setState({
        stationselected_tp: station_tp,
        legend: null,
        //  legendVisible:false
      });
    }
    else {
      this.setState({
        visibleGraphPanel: false,
        series: null,
        stationselected_tp: station_tp
      })
    }

  };*/
    setCatchmentChange = (catchment) => {
    //console.log("catchment",catchment)
    if (catchment!== null || '#') {
      this.setState({
        catchmentselected:catchment ,

        stationselected: '#',
        datesselected:'#',
        reservoirsselected:'#',
        legend: null,
       // datesselected:'#'
        //  legendVisible:false
      });
      

    }
    else {
      this.setState({
        visibleGraphPanel: false,
        series: null,
        catchmentselected: catchment,
      })
    }

  };
  setDatesChange = (date_avail) => {
    
    if (date_avail!== '#' ||  null) {
      this.setState({
        datesselected:date_avail ,
        stationselected: '#',
       
       
        reservoirsselected:'#',

        legend: null,
        //  legendVisible:false
      });

    }
    else {
      this.setState({
        visibleGraphPanel: false,
        series: null,
        datesselected: date_avail,
      })
    }

  };



setReservoirChange = (reservoir) => {
  if (reservoir !== '#') {
    this.setState({
      reservoirsselected:reservoir ,
      stationselected:'#',
      catchmentselected:'#',
      catchmentfilename:'#',
      datesselected:'#',


      legend: null,
      //  legendVisible:false
    });
    
  }
  else {
    this.setState({
      visibleGraphPanel: false,
      series: null,
      reservoirsselected: reservoir
    })
  }
};
/*
  setReservoirChange_tp = (reservoir_tp) => {
    if (reservoir_tp !== '#') {
      this.setState({
        reservoirsselected_tp:reservoir_tp ,
  
        //  legendVisible:false
      });
      
    }
    else {
      this.setState({
        visibleGraphPanel: false,
        series: null,
        reservoirsselected_tp: reservoir_tp
      })
    }

};
*/
  // handleGodavari=()=>{
  //     this.setState(
  //         {
  //             basinselection:true
  //         }
  //     )
  // }

  showBaseLayer = () => {
    this.setState({
      baselayers: true,
    });
  };
  hideBaseLayer = () => {
    this.setState({
      baselayers: false,
    });
  };


  baseLayerChange = (event) => {
    //console.log(event);
    this.setState({
      baselayerselected: event.target.value,
    });
  };

  handleDialogClose = () => {
    this.setState({
      technicalnoteenable: false,
    });
  };
  handleDialogDClose = () => {
    this.setState({
      disclaimerenable: false,
    });
  };
  handleTechnicalNote = () => {
    this.setState({
      technicalnoteenable: true,
      disclaimerenable: false,
      visibleGraphPanel: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };
  handleListofVillages = async () => {

    this.setState({
      technicalnoteenable: false,
      disclaimerenable: false,
      visibleGraphPanel: false,
      modalpopup: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  }
  handleDisclaimer = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: true,
      visibleGraphPanel: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };
  incrementCounter = () => {
    // this.setState((prevState) => {
    //     // Important: read `state` instead of `this.state` when updating.
    //     return {clickcount: Number(prevState.countcount) + 1}
    //   });
    this.setState({
      clickcount: this.state.clickcount + 1,
    });
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  handleInundatedMap = (event) => {
    let village_legend = `${domain.village_legend}`
    if (event.target.checked) {
      this.setState({
        villageaffected: true,
        village_legend: village_legend
      })
    }
    else {
      this.setState({
        villageaffected: false,
        village_legend: null
      })
    }
  }
  handleInundatedVillages = async () => {

    let result = await axios.get(`${domain.DBServer}/get-villages-affected`)
    if (result) {
      if (result.data) {
        this.setState({
          villages_affected_data: result.data
        })
      }
    }
    this.setState({
      modalpopup: true
    })
  }
  handleCheckChieldElement = (event) => {
    let overlay = this.state.basinoverlays;

    overlay.forEach((overlay) => {
      if (overlay.value === event.target.value)
        overlay.isChecked = event.target.checked;
    });
    this.getLegend(overlay);
    this.setState({ basinoverlays: overlay });
  };
  render() {
    //console.log(this.state);
    //console.log("Chart Position:", { x: this.state.x, y: this.state.y });
  //console.log("Chart Position Size:", { width: this.state.width, height: this.state.height });

    let params = new URLSearchParams(this.props.location.search);
    let village_data;

   
    let menuList = this.state.tabs.map((child) => {
      //console.log(child.name);
      // if(child.name!=='Spatial Snowmelt'){
      return (
        <div style={{ padding: "5px" }} key={child.id}>
          <TreeNode
            data={child}
            stations={this.state.stations}
            catchment={this.state.catchment}
            stations_tp={this.state.stations_tp}
            reservoirs_tp={this.state.reservoirs_tp}
            //dates_avail={this.state.dates_avail}
            getAvailableDates={this.getAvailableDates}
            getCatchmentRegion={this.getCatchmentRegion}
            setCatchmentRegion={this.setCatchmentRegion}
            reservoirs={this.state.reservoirs}
            forecast_date_gd={this.state.forecast_date_gd}
            forecast_date_tp={this.state.forecast_date_tp}
            dates_avail={this.state.dates_avail}
            catchmentcode={this.state.catchmentcode}
            catchmentregion={this.state.catchmentregion}
            filename={this.state.filename}
            handleTabClick={this.handleTabClick}
            id={child.id}
            station_height={this.state.station_height}
            incrementCounter={this.incrementCounter}
            clickcount={this.state.clickcount}
            active={child.active}
            handleInundatedMap={this.handleInundatedMap}
            handleInundatedVillages={this.handleInundatedVillages}
            simulationselected={this.state.simulationselected}
            latestsimulations_names={this.state.latestsimulations_names}
            setSimulationChange={this.setSimulationChange}
            setSixHourSimulationChange={this.setSixHourSimulationChange}
            setCatchmentChange={this.setCatchmentChange}

            setSelectedMenu={this.setSelectedMenu}
            setSelectedLayer={this.setSelectedLayer}
            basinselected={this.state.basinselected}
            handleStationChange_map={this.handleStationChange_map}
            handleStationChart={this.handleStationChart}
            handleStationChartNew={this.handleStationChartNew}
            catchmentfilename={this.state.catchmentfilename}
            

            setBasinSelected={this.setBasinSelected}
            margin={0}
            selectedLayerLink={params.get("selected")}
            toggleSelectedNodeStatus={this.toggleSelectedNodeStatus}
            selectedNodeStaus={this.state.selectedNodeStaus}
            enableDatePicker={this.enableDatePicker}
            enableSlider={this.enableSlider}
            enableForecast={this.enableForecast}
            color={colors["sidebar-main-menu"]}
            setDefaultInfo={this.setDefaultInfo}
            date={
              moment.isMoment(this.state.date)
                ? this.state.date.format("DD MMMM YYYY")
                : moment(this.state.date, "DD-MM-YYYY").format("DD MMMM YYYY")
            }
            setDate={this.setDate}
            setStationChange={this.setStationChange}
            //setStationChange_tp={this.setStationChange_tp}

            stationselected={this.state.stationselected}
            //stationselected_tp={this.state.stationselected_tp}

            setReservoirChange={this.setReservoirChange}
            //setReservoirChange_tp={this.setReservoirChange_tp}

            setDatesChange={this.setDatesChange}
            catchmentselected={this.state.catchmentselected}
            reservoirsselected={this.state.reservoirsselected}
            reservoirsselected_tp={this.state.reservoirsselected_tp}

 
            datesselected={this.state.datesselected}


            inundationmapstatus={this.state.inundationmapstatus}
          />
        </div>
      );
    });
    if (this.state.villages_affected_data !== null) {
      village_data = this.state.villages_affected_data.map((result) => {
        return (<tr>
          <td>{capitalize(result.state)}</td>
          <td>{capitalize(result.dname)}</td>
          <td>{capitalize(result.dmname)}</td>
          <td>{capitalize(result.dvname)}</td>
          <td>{result.per_inunda}</td>
        </tr>)
      })
    }
    return (
      <div
        style={{ backgroundColor: colors.textcolor, height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
        <AboutModal
          modal={this.props.floodmodal}
          toggle={this.props.toggle}
          title={pagecontent.title}
          bodycontent={pagecontent.bodycontent}
          link={pagecontent.link}
        />
        <Sidebar.Pushable
          style={{
            marginTop: "0px",
            backgroundColor: "blue",
            border: "0px",
            transfrom: "0px",
          }}
        >
          <Sidebar
            as={Menu}
            animation="push"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.state.visible}
            // width='wide'
            style={{
              backgroundColor: colors.background,
              width: "260px",
              padding: "0px",
              border: "0px",
              margin: "0px",
            }}
          >
            {this.state.dateEnabled ? (
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                }}
              >
                <DateInput
                  // inline
                  name="date"
                  value={moment(this.state.date, "DD-MM-YYYY").format(
                    "DD-MM-YYYY"
                  )}
                  onChange={this.handleDateChange}
                  placeholder="Date"
                  iconPosition="left"
                  closable
                  initialDate={this.state.date}
                  //value={this.state.date}
                  enable={this.state.availableDates}
                  marked={this.state.availableDates}
                  markColor="teal"
                  startMode="day"
                  pickerWidth="300px"
                  popupPosition="top right"
                  clearIcon={<Icon name="remove" color="red" />}
                />
              </div>
            ) : null}

            {this.state.layerExist === true ? (
              <div></div>
            ) : (
                <div style={{ padding: "10px", textAlign: "left" }}>
                  <Message warning>
                    <Message.Header>Data does not exist </Message.Header>
                    <p>
                      Data does not exist for the selected date. The data being
                      displayed is for the last date selected.
                  </p>
                  </Message>
                </div>
              )}

            <div className="modalwindow">
              <div className="modalheader" style={{ textAlign: "center" }}>
                <div class="grid-container">
                  <div
                    class="grid-child"
                    style={{ width: "50px", padding: "0px" }}
                  >
                    Select Basin
                  </div>
                  <div class="grid-child">
                    <select
                      onChange={this.handleBasinChange}
                      value={this.state.basinselected}
                    >
                      <option value="Godavari">Godavari</option>
                      <option value="Tapi">Tapi</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="modalbox"
                style={{ textAlign: "left", padding: "0px" }}
              >
                {menuList}
              </div>
              <div>

              </div>
            </div>

            <div className="modalwindow">
              <div className="modalheader" style={{ textAlign: "left" }}>
                Overlay
              </div>
              <div
                className="modalbox"
                style={{ textAlign: "left", padding: "0px" }}
              >
                <ul
                  style={{ textAlign: "left", padding: "0px", margin: "0px" }}
                >
                  {this.state.basinoverlays.map((overlays) => {
                    return (
                      <CheckBox
                        handleCheckChieldElement={this.handleCheckChieldElement}
                        {...overlays}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors["textcolor"], textAlign: "left" }}
              >
                Information
              </div>

              <div className="modalbox">
                Inundation layers will be displayed during flood event only<br/>
                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleTechnicalNote}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleDisclaimer}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>

          </Sidebar>

          <Sidebar.Pusher
            dimmed={false}
            style={{ height: "100%", backgroundColor: colors["textcolor"] }}
          >
            <div
              style={{
                height: "100%",
                width: "100%",
                padding: "0px",
                border: "0px",
                backgroundColor: colors["textcolor"],
              }}
            >
              <MapView
                village_legend={this.state.village_legend}
                villageaffected={this.state.villageaffected}
                zoom_reset={this.state.zoom_reset}
                in_boundary={this.state.in_boundary}
                legend={this.state.legend}
                catchmentfilename={this.state.catchmentfilename}
                legend_array_overlay={this.state.legend_array_overlay}
                legendVisible={this.state.legendVisible}
                setLatLng={this.setLatLng}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                pointInfo={this.state.pointInfo}
                setLegend={this.setLegend}
                selectedLayer={this.state.selectedLayer}
                visibleLeft={this.state.visible}

                //catchmentregion={this.state.catchmentselected}
                //catchmentdate={this.state.datesselected}
                visibleGraphPanel={this.state.visibleGraphPanel}
                handleAnimationChange={this.handleAnimationChange}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                displayLegend={this.displayLegend}
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                toggleVisibleGraphPanel_hd={this.toggleVisibleGraphPanel_hd}

                visibleDivPanel={this.state.visibleDivPanel}
                toggleDivPanel={this.toggleDivPanel}
                basinoverlays={this.state.basinoverlays}
                baselayerselected={this.state.baselayerselected}
                basinselected={this.state.basinselected}
                getFeatureInfo={this.getFeatureInfo}
                setStateInfo={this.setStateInfo}
                forecast={this.state.forecast}
                series={this.state.series}

                series_hd={this.state.series_hd}
                series_volume={this.state.series_volume}


                activeDate={
                  moment.isMoment(this.state.date)
                    ? this.state.date.format("DD MMMM YYYY")
                    : moment(this.state.date, "DD-MM-YYYY").format(
                      "DD MMMM YYYY"
                    )
                }
                forecastdate={this.state.forecastdate}
                setDate={this.setDate}
                makeChartDataNDays={this.makeChartDataNDays}
                makeChartDataAvailableDaysWithDateCats={
                  this.makeChartDataAvailableDaysWithDateCats
                }
                onClickDetails={{ ...this.state.onClickDetails }}
                setOnClickDetails={this.setOnClickDetails}
                slider={this.state.sliderEnabled}
                information={this.state.information}
                stateInfo={this.state.stateInfo ? this.state.stateInfo : null}
                sliderOptions={{
                  onClickSlideLeft: this.onClickSlideLeft,
                  onClickSlideRight: this.onClickSlideRight,
                  onSlide: this.onSlide,
                  slideTracker: this.state.slideTracker,
                  max: this.state.availableDates.length - 1,
                  date: moment(
                    this.state.availableDates[this.state.slideTracker],
                    "YYYYMMDD"
                  ).format("D MMM YYYY"),
                }}
                himalayan_boundary={this.state.himalayan_boundary}
                geojsonadd={this.state.basininfo}
                station_boundary={this.state.station_boundary}
                indundation_map_boundary={this.state.indundation_map_boundary}
                stationselected={this.state.stationselected}
                reservoirsselected={this.state.reservoirsselected}
                stationselected_tp={this.state.stationselected_tp}
                reservoirsselected_tp={this.state.reservoirsselected_tp}

                catchmentselected={this.state.catchmentselected}
                simulationselected={this.state.simulationselected}
                datesselected={this.state.datesselected}
              />
            </div>
            {
              this.state.modalpopup ?
                <Rnd
                  style={{ zIndex: "200", background: "white" }}
                  size={{ width: this.state.width, height: this.state.height }}
                  position={{ x: this.state.x, y: this.state.y }}
                  onDragStop={(e, d) => {
                    this.setState({ x: d.x, y: d.y });
                  }}
                  onResizeStop={(e, direction, ref, delta, position) => {
                    this.setState({
                      width: ref.style.width,
                      height: ref.style.height,
                      ...position,
                    });
                    //console.log("position",position)
                  }}
                > <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="minimizebox"
                        onClick={this.handleListofVillages}
                      ></div>
                      List of villages expected to get inundated as on
            </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" style={{ overflowY: "auto" }}>
                        <table className="table table-border">
                          <tr>
                            <th className="col">State</th>
                            <th className="col">District</th>
                            <th className="col">Mandal</th>
                            <th className="col">Village</th>
                            <th className="col"> % area inundated </th>

                          </tr>
                          {village_data}
                        </table>

                      </div>


                    </div>
                  </div>

                </Rnd> : null
            }
            {this.state.technicalnoteenable || this.state.disclaimerenable ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.technicalnoteenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogClose}
                      ></div>
                      Technical Note
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" style={{ overflowY: "auto" }}>
                        <p align="justify">
                          Under National Hydrology Project (NHP) Real-time Operational Spatial Flood Early Warning System is developed for the major floodplains of Godavari and Tapi river basins using space based inputs through hydrological and hydrodynamicmodelling approach. Spatial flood inundation simulation models using high resolution ALTM DTM in the major floodplains of the rivers and Carto10 m DEM for other prominent flood plains which will be used for issuing flood advisory to the concerned disaster management authorities.
                    </p>
                        <p ><span style={{ color: "blue" }}>Objective</span></p>

                        <p align="justify">
                          <ul><li>To develop medium-range flood early warning models for the major floodplains of two study river basins using space based inputs through hydrological modelling approach</li>
                            <li>	To develop spatial flood inundation simulation models using high resolution DEM in the major floodplains of the rivers.</li>
                            <li>	To develop web-enabled real-time spatial flood early warning system. </li>
                            <li>	To develop workflow for issuing flood advisory to the concerned disaster management authorities during the flood event.</li>
                            <li>	Generation of flood inundation scenarios in the main flood-plains of the rivers under different flood return periods.</li>
                          </ul>
                        </p>
                        <p ><span style={{ color: "blue" }}>
                          Input datasets Used </span></p>

                        <p align="justify">
                          <span style={{ color: "blue" }}>Land Use Land Cover (LULC)</span> : Land use/Land cover (LULC) data generated under Natural Resources Census (NRC) at 56m spatialresolution is one of the main inputs used for deriving the Nedbør-Afstrømnings-Model (NAM) parameters. The parameters computed by NAM are - Maximum water content in surface storage, Maximum water content in root zone storage, Overland flow runoff coefficient, Time constant for interflow, Root zone threshold value for overland flow, Time constant for routing overland flow, Root zone threshold value for interflow, Root zone threshold value for groundwater recharge and Time constant for routing base flow</p>
                        <p align="justify"><span style={{ color: "blue" }}>Digital Elevation Model (DEM) </span>:Carto DEM of 30 m resolution is used for delineation of basin. Airborne Laser Terrain Mapper(ALTM)Digital Terrain Model of 0.5m resolution  was  utilized for extraction of cross-sections along the river, extraction of bathymetry, and generation of flexible mesh in the flood plains. </p>
                        <p align="justify"><span style={{ color: "blue" }}>Soil Data</span> :National Bureau of Soil Survey and Land Use Planning (NBSS&amp;LUP) 1:50,000-scale soil map was used to derive the characteristics of soil texture which influences the parameters such as maximum water content in the surface storage, maximum water content in root zone storage, overland flow runoff coefficient, and time constant for routing overland flow etc. (https://www.nbsslup.in/)</p>
                        <p align="justify"><span style={{ color: "blue" }}>Meteorological Datasets </span>:Indian Meteorological Department’s real-time rainfall data (point data) and IMD’s forecast rainfall data (two day forecast only) are used as meteorological inputs in flood early warning model. Discharge data of CWC gauge sites are used for calibration  and validation of the of the model.</p>


                        <p ><span style={{ color: "blue" }}>
                          Methodology</span>
                        </p>

                        <p align="justify">
                          The framework adopted for development of spatial flood inundation simulation model has been shown in fig-1. It includes extraction of the topographic and hydraulic parameters from the Digital Elevation Model, Soil Data and LULC Data. The meteorological datasets are incorporated in the refined model to compute the flood hydrographs. Using the observed discharge data the Model is calibrated and validated. The calibrated hydrograph and the topographic inputs are used for spatial flood inundatino simulation modeling. The spatial flood inundation simulations are calibrated and validated against the available satellite datasets.
</p>
                        <img src={Methodology} />
                        <p ><span style={{ color: "blue" }}>
                          Model Calibration and Validation</span>
                        </p>
                        <p align="justify">
                          Model is calibrated basin wise using CWC field discharge data. The validation has been done subsequently and computed flood hydrograph were compared with the observed data. The Model Calibration and Validation was done using multiple year data corresponding to various flood events. The results indicate high (Ef) of the the computed hydrograph vis-à-vis the observed hydrograph.TheNash-Sutcliffe Efficiency is a normalized statistic that determines the relative magnitude of the residual variance compared to the measured data variance.It is widely used and is a potentially reliable statistic for assessing the goodness of fit of hydrologic models
</p>
                        <p ><span style={{ color: "blue" }}>
                          Products</span></p>
                        <p align="justify">
                          <span style={{ color: "blue" }}>Flood Hydrographs </span>: Forecasted Flood hydrograph for two successive days at various locations in the Basin.
<span style={{ color: "blue" }}>Spatial Flood Inundation Extent and Depth </span>: Spatial Flood inundation and the depth of flooding
</p>




                        <br />
                        <br />
                      </div>
                    </div>
                    {/* 
    <div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : this.state.disclaimerenable ? (
                  <div id="divDialog" class="dialog boxshadow"   >
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogDClose}
                      ></div>
                      Disclaimer
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" >
                        <ol type="1" style={{ textAlign: "justify" }}>
                        <li>
                            {" "}
                            Automated flood early warning system for Godavari and Tapi running at CWC, Delhi on an experimental basis.
                        </li>
                        <li>
                            {" "}
                            Reservoir integration is in  progress, Hence it may not be accurate.
                        </li>
                          <li>
                            {" "}
                            Flood forecast models are being run for Godavari and
                            Tapi rivers using real time rainfall data obtained
                            from IMD and forecast data obtained from IMD WRF and
                            GEFS. Accuracy of result is subjected to accuracy of
                            rainfall products.
                        </li>
                          <li>
                            Models are being run assuming full reservoir condition
                            as no real time operational data available. Hence the
                            forecast discharges may not be accurate.
                        </li>
                          <li>
                            Presently this is being run on experimental mode to
                            have an understanding and cannot be used for any real
                            time operation.
                        </li>
                          <li>
                            Spatial inundation simulations are not calibrated.
                            Hence it may not be appropriate.
                        </li>
                          <li>
                            This forecast system is to give overall flood
                            condition in the Godavari and Tapi basins. Data from
                            different sources being used without quality check in
                            real-time. NRSC is not responsible for any wrong flood
                            alerts given through this system.
                        </li>
                          <li>
                            Model error may be more in lean period computations.
                        </li>
                          <li>
                            Flood inundation layers will be displayed during flood
                          period only.{" "}
                          </li>
                          <li>
                            The accuracy of basemap layers (Source: Bhuvan), overlay layers like Basin, Subbasin, River ,Hydrological Observation Stations and Reservoirs (Source: India-WRIS) rests with the respective owners and they are used here for visualisation purpose only.
                        </li>
                        </ol>
                      </div>
                      
                    </div>
                  </div>
                ) : (
                      <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.chartloading}
                        />
                      </div>
                    )}
              </Rnd>
            ) : null}

            {this.state.visibleGraphPanel ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height:this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={this.onDragStop}
                onResizeStop={this.onResizeStop}
              >
                


            {this.state.series !== null && !this.state.chartloading ? (
                  <MultiAxisChart
                    categories_volume={this.state.categories_volume}
                    series_volume={this.state.series_volume}
                    categories={this.state.categories}
                    data={this.state.series}
                    curr_date={this.state.curr_date}
                    charttitle={this.state.charttitle}
                    station_height={this.state.station_height}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}

                    inflow_title={this.state.inflow_title}
                    volume_title={this.state.volume_title}
                    water_title={this.state.water_title}
                    selectedOption={this.state.selectedOption}
                    handleOptionChange={this.handleOptionChange}
                  />
                  
                  
                ) : (
                    <div className="sweet-loading">
                      <FadeLoader
                        // css={override}
                        sizeUnit={"px"}
                        // size={150}
                        color={"#123abc"}
                        loading={this.state.chartloading}
                      /> 
                    </div>
                  
                  )}

{this.state.series_hd !== null && !this.state.chartloading ? (
                  <MultiAxisChartHydrograph
                    series={this.state.series_hd}
                    categories={this.state.categories_hd}
                    data={this.state.series_hd}
                    curr_date={this.state.curr_date}
                    time={this.state.time_rainfall}
                    charttitle={this.state.charttitle_hd}
                    //station_height={this.state.station_height}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel_hd}
                  />
                  
                  
                ) : (
                    <div className="sweet-loading">
                      <FadeLoader
                        // css={override}
                        sizeUnit={"px"}
                        // size={150}
                        color={"#123abc"}
                        loading={this.state.chartloading}
                      /> 
                    </div>
                  
                )}








              </Rnd>
            ) : null}         
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}


export default MapContainer;
